import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function Instructor({ onOpenDrawer }) {
  const { t } = useLanguage();

  return (
    <section id="instructor">

      <div className="container">
        
          <div className="checkerboard-content">
            <div className="checkerboard-image">
              <div className="mission-image-placeholder">
                <img src="/images/mike.webp" alt="Mike" />
              </div>
            </div>
            <div className="checkerboard-text">
              <h2 className="section-title">{t.instructor.title}</h2>

              <p className="mission-description" style={{ marginTop: '0px'}} >
                {t.instructor.description1}
              </p>

              <p className="mission-description" style={{ marginTop: '0px'}}>
                {t.instructor.description2}
              </p>
              <p className="mission-description" style={{ marginTop: '0px'}}>
                {t.instructor.description3}
              </p>
              <p className="mission-description" style={{ marginTop: '0px'}}>
                {t.instructor.description4}
              </p>
              <p className="mission-description" style={{ marginTop: '0px'}}>
                {t.instructor.description5}
              </p>

 <p>
              {/* <button onClick={onOpenDrawer} className="btn" style={{ display: 'inline-block', marginTop: '15px', border: '2px solid var(--accent-red)' }}>
                Read More About Michele
              </button> */}
            </p>
              
              
            </div>

            
          </div>
      </div>

    </section>


      
  );
}

export default Instructor;
